import React from "react";
import PropTypes from "prop-types";
import {Box} from "@material-ui/core";

const CustomSliderArrow = ({ className, style, onClick, children }) => {
    return (
        <Box
            className={className}
            style={{ ...style}}
            onClick={onClick}
        >
            {children}
        </Box>
    );
};


CustomSliderArrow.defaultProps = {
    direction: "forward",
};

CustomSliderArrow.propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.element
};

export default CustomSliderArrow;

